export class UserRolesResponse {
    public roles: string[];

    constructor() {
        this.roles = new Array<string>();
    }
}
